export default {
      id: "action-icon-approve-sensitive-data-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-approve-sensitive-data",
      toString: function () {
        return this.url;
      }
    }